import { UserMinus } from 'lucide-react';
import { useDataProvider } from 'ra-core';
import { type AdminDataProvider } from '../../../api/adminDataProvider';
import { CustomBulkAction } from '../../Moonstar/CustomBulkAction';

export const BulkRemoveUserGroupMembers = (props: { groupId: number }) => {
  const dataProvider = useDataProvider<AdminDataProvider>();

  return (
    <CustomBulkAction
      mutationFn={(userIds) =>
        dataProvider.removeUserGroupMembers({
          data: userIds.map((userId) => ({
            groupId: props.groupId,
            userId,
          })),
        })
      }
      label="ra.action.remove"
      variant="destructive"
      buttonIcon={<UserMinus />}
      successMessage="moonstar.user-group-members.remove.successMessage"
    />
  );
};
